import { render, staticRenderFns } from "./DataFormViewer.vue?vue&type=template&id=32e41064&"
import script from "./DataFormViewer.vue?vue&type=script&lang=js&"
export * from "./DataFormViewer.vue?vue&type=script&lang=js&"
import style0 from "./DataFormViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports